import spacetime from 'spacetime';
import { CompanySettingTimeFormatEnum } from '../../../api/v1';

export const formatDateToTimeString = (
  date: Date | null,
  timeFormat: CompanySettingTimeFormatEnum,
  timezone: string,
): string => {
  if (!date) return '';
  const timeFormatTemplate =
    timeFormat === CompanySettingTimeFormatEnum._24
      ? '{hour-24-pad}:{minute-pad}'
      : '{hour-pad}:{minute-pad} {ampm}';
  const dateString = String(
    spacetime(date, timezone).format(timeFormatTemplate),
  );
  return dateString || '';
};
